import { Anchor, IAnchorProps } from "@/components/Anchor";
import { withRouteNavigator } from "@/infrastructure/Route/withRouteNavigator";

export const RouteAnchor = withRouteNavigator<IAnchorProps>(Anchor);
